<template>
  <f7-list-item
    :media-item="true"
    :title="`${startDate} - ${endDate}`"
    :after="(contract.startDate <= currentDate && contract.endDate >= currentDate) ? 'ACTIVO' : 'FINALIZADO'"
    :link="true"
    class="content-contract-item"
    @click="navigateToContract"
  >
    <template #subtitle>
      <div>
        <div class="item-subtitle__title">
          {{ (contract.state === 0) ? 'En firme' : 'Propuesta' }}
        </div>
        <div class="item-subtitle__info">
          <span>{{ totalAmount }}</span> €
        </div>
      </div>
    </template>

    <template #default>
      <div>
        <div
          v-for="line in contract.lines"
          :key="line.id"
          class="item-products"
        >
          <div>
            <div class="item-products__product">
              {{ line.varietyName }}
            </div>
            <div class="item-products__quantity">
              <span>{{ line.quantity }} {{ $t('common.kg').toUpperCase() }}</span> {{ `(${line.price}€/${$t('common.kg').toUpperCase()})` }}
            </div>
          </div>
          <div class="item-products__price">
            <div>
              <span>{{ line.amount }}</span> €
            </div>
          </div>
        </div>
        <!-- <ul>
        <f7-list-item
          v-for="line in contract.lines"
          :key="line.id"
          :link="false"
          :media-item="true"
          :title="line.varietyName"
          :footer="`${line.quantity} ${$t('common.kg').toUpperCase()}   (${line.price}€/${$t('common.kg').toUpperCase()})`"
          :after="`${line.amount} €`"
        />
        </ul> -->
      </div>
    </template>
  </f7-list-item>
</template>

<script>
import { formatDate } from '@/js/utils/date';
import { f7 } from 'framework7-vue';

export default {
  name: 'ContractItem',
  props: {
    contract: { type: Object, default: undefined },
  },
  data() {
    return {
      currentDate: new Date().toISOString().split('T')[0],
      startDate: formatDate(this.contract.startDate, 'DD/MM/YYYY'),
      endDate: formatDate(this.contract.endDate, 'DD/MM/YYYY'),
    };
  },
  computed: {
    totalAmount() {
      return this.contract.lines.reduce((acc, l) => acc + l.amount, 0);
    },
  },
  methods: {
    navigateToContract() {
      f7.views.main.router.navigate('/new-contract/', {
        props: {
          contractId: Number.parseInt(this.contract.id, 10),
        },
      });
    },
  },
};
</script>

<style lang="scss">
.content-contract-item {
  .item-inner {
    &::after {
      background-color: var(--his-gray);
    }
  }

  .item-title-row {
    padding-left: 5px;

    .item-title {
      font-size: 12px;
      font-weight: 500;
      color: var(--his-darkgray);
    }

    .item-after {
      font-size: 14px;
      font-weight: 700;
      color: var(--his-darkgray);
    }

    &::before {
      color: var(--his-blueberry-frost) !important;
    }
  }

  .item-subtitle {
    background-color: var(--his-coconut-milk);
    padding-left: 5px;
    margin-top: 8px;
    border-radius: 3px;

    >div {
      display: flex;
      justify-content: space-between;
      text-align: center;
    }

    &__title {
      align-self: center;
      color: var(--his-darkgray);
      font-weight: 400;
      font-size: 12px;
    }

    &__info {
      min-width: 60px;
      color: var(--his-darkgray);
      background-color: var(--his-lighblue);
      padding: 2px 10px;
      border-radius: 3px;

      span {
        font-weight: 700;
      }
    }
  }

  .item-products {
    background-color: var(--his-coconut-milk);
    padding-left: 5px;
    margin-top: 5px;
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
    text-align: center;

    &__product {
      font-size: 14px;
      font-weight: 500;
      color: var(--his-dark-blue);
      padding-top: 5px;
    }

    &__quantity {
      color: var(--his-darkgray);
      font-size: 14px;
      font-weight: 400;
      display: flex;
      justify-content: flex-start;
      padding-bottom: 5px;

      span {
        font-weight: 700;
      }
    }

    &__price {
      background-color: var(--his-banana-cream);
      min-width: 60px;
      padding: 2px 10px;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;

      div {
        color: var(--his-darkgray);

        span {
          font-weight: 700;
        }
      }
    }
  }
}
</style>
